module.exports = __webpack_public_path__ + "img/employee_icon.7b009c95.png";